import PageMeta from './PageMeta';

export default PageMeta;
